import { API_URLS, getApiUrl } from '../Utils/apiURLConfiguration';
import GWRApiClient from './GWRApiClient';

/**
 * Concrete implementation for the Reservation endpoints
 *
 * @class ReservationsApiClient
 * @extends {GWRApiClient}
 */
export default class ReservationsApiClient extends GWRApiClient {
  /**
   * @constructor
   * Calls parent constructor.
   * If there isn't any url provided, then we use the default from the environment variable
   * fills the url and token information
   * @param {string} url
   *  The url where the service endpoints are
   * @param {string} token
   *  The token of the logged user
   */
  constructor(version = '', token = '') {
    let apiVersion = version !== '' ? version : `v2`;

    const urlAux = getApiUrl(API_URLS.REACT_APP_RESERVATION_SERVICE_ENDPOINT, apiVersion);

    super(urlAux, token);
  }

  /**
   * @function
   * Get's an object that specifies wether or not the reservetation is elligible for virtual check-in,
   * it's worth noticing that reservation is elligible for virtual checking if it's due to 24h, there
   * maybe some cases when the Nor1 API isn't synced so it may respond with a non elligible flag.
   * @param {number} reservationId Reservation number.
   */
  async getReservationCheckIn(reservationId) {
    const urlRequest = `${this.url}/${reservationId}/check-in`;

    const request = await super.getApiCallAuth(urlRequest);

    return request;
  }

  /**
   * @deprecated This function and the components where it's used should be removed in a future release.
   * Get all reservations by Phone number and last four numbers of the Credit Card
   * @param {string} phone
   * @param {int} creditCard
   */
  async getAllReservationsByPhoneAndCc(phone, creditCard) {
    const urlRequest = `${this.url}/phone`;

    let queryParams = {
      PhoneNumber: phone,
      LastFourCc: creditCard
    };

    let request = await super.getApiCallAuth(urlRequest, queryParams);

    return request;
  }

  /**
   * @function
   * Get all reservations by Email and last four numbers of the Credit Card
   * @param {string} email
   * @param {int} creditCard
   */
  async getAllReservationsByEmailAndCc(email, creditCard) {
    const urlRequest = `${this.url}/email`;

    let queryParams = {
      Email: email,
      LastFourCc: creditCard
    };

    let request = await super.getApiCallAuth(urlRequest, queryParams);

    return request;
  }

  /**
   * @function
   * Get all reservations by Reservation Id and Last Name
   * @param {int} reservationId
   * @param {string} lastName
   */
  async getReservationsByIdAndLastName(reservationId, lastName) {
    const urlRequest = `${this.url}/last-name`;

    let queryParams = {
      ReservationId: reservationId,
      LastName: lastName
    };

    let request = await super.getApiCall(urlRequest, queryParams);

    return request;
  }

  /**
   * @function
   * Get reservations by Reservation Id and Reservation Key
   * @param {number} reservationId
   * @param {string} reservationKey
   */
  async getReservationsByIdAndReservationKey(reservationId, reservationKey) {
    const urlRequest = `${this.url}/fetch`;

    const queryParams = {
      ReservationId: reservationId,
      ReservationKey: reservationKey
    };

    const request = await super.getApiCall(urlRequest, queryParams);

    return request;
  }

  /**
   * @function
   * Send a PUT request to cancel the reservation by Id.
   * @param {number} reservationId
   */
  async cancelReservationById(reservationId) {
    const actionUrl = `${reservationId}/cancel`;

    const urlRequest = `${this.url}/${actionUrl}`;

    let request = await super.putApiCallAuth(urlRequest, {});

    return request;
  }

  /**
   * @function
   * Send a PUT request to modify a reservation.
   * @param {Object} reservation Reservation payload.
   * The reservation modified fields
   */
  async modifyReservation(reservation) {
    const urlRequest = `${this.url}/modify`;

    let request = await super.putApiCall(urlRequest, reservation);

    return request;
  }

  /**
   * Add a cabana for your reservation
   * @param {Object} Cabanas payload object
   */
  async addCabana(cabanasRequest) {
    const urlRequest = `${this.url}/cabana`;
    return super.postApiCall(urlRequest, cabanasRequest);
  }

  async addCabanaV3(reservationId, cabanasRequest, lastName) {
    const urlRequest = `${this.url}/${reservationId}/packages/cabana?last-name=${lastName}`;
    return super.postApiCall(urlRequest, cabanasRequest);
  }

  async fetchCabanasV3(resId) {
    const urlRequest = `${this.url}/${resId}/packages/availability/cabana`;

    let result = await super.getApiCall(urlRequest);

    return result;
  }
}
